import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  saveLoadingById: false,
  assignCompetenciesLength: 0,
  assignCompetencies: [],
  assignCompetencie: {},
  assignCompetenciesError: "",
  formError: "",
};

export default function AssignCompetenciesReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_ASSIGN_COMPETENCIES:
      return { ...state, loading: action.payload };
    case actions.LOADING_ASSIGN_COMPETENCIES_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.SAVE_LOADING_ASSIGN_COMPETENCIES:
      return { ...state, saveLoading: action.payload };
    case actions.SAVE_LOADING_ASSIGN_COMPETENCIES_BY_ID:
      return { ...state, saveLoadingById: action.payload };
    case actions.GET_ASSIGN_COMPETENCIES:
      return {
        ...state,
        assignCompetencies: action.payload.assignCompetencies,
        assignCompetenciesLength: action.payload.assignCompetenciesLength,
      };
    case actions.GET_ASSIGN_COMPETENCIES_BY_ID:
      return {
        ...state,
        assignCompetencie: action.payload,
      };
    case actions.FORM_FAIL_ASSIGN_COMPETENCIES:
      return { ...state, formError: action.payload };
    case actions.ASSIGN_COMPETENCIES_FAIL:
      return { ...state, assignCompetenciesError: action.payload };
    default:
      return state;
  }
}